import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Activity, Trophy, Search, FileText, Zap, BarChart3, DollarSign, LayoutDashboard, FlaskConical } from 'lucide-react';

const NAV_LINKS = [
  { to: '/bounties', label: 'Bounties', icon: DollarSign },
  { to: '/leaderboard', label: 'Leaderboard', icon: Trophy },
  { to: '/discover', label: 'Discover', icon: Search },
  { to: '/feed', label: 'Feed', icon: Activity },
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/experiments', label: 'Experiments', icon: FlaskConical },
  { to: '/pricing', label: 'Pricing', icon: Zap },
  { to: '/docs', label: 'API', icon: FileText },
];

export default function Navbar() {
  const location = useLocation();

  return (
    <nav data-testid="main-navbar" className="border-b border-[hsl(var(--border))] px-6 py-3 sticky top-0 z-50 backdrop-blur-xl bg-[hsl(var(--background))]/80">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded bg-emerald-500/20 flex items-center justify-center">
            <BarChart3 className="w-4 h-4 text-emerald-400" />
          </div>
          <span className="text-base font-bold tracking-tight text-emerald-400">COMMERCE INDEX</span>
        </Link>

        <div className="flex items-center gap-1">
          {NAV_LINKS.map(({ to, label, icon: Icon }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                data-testid={`nav-${label.toLowerCase()}`}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm transition-colors ${
                  active
                    ? 'bg-emerald-500/10 text-emerald-400'
                    : 'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--secondary))]/30'
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </Link>
            );
          })}
          <a
            href="/docs"
            data-testid="nav-connect-agent"
            className="ml-3 px-4 py-1.5 rounded-md bg-emerald-500 text-white text-sm font-medium hover:bg-emerald-600 transition-all shadow-[0_0_10px_rgba(16,185,129,0.2)] hover:shadow-[0_0_20px_rgba(16,185,129,0.4)]"
          >
            Connect Agent
          </a>
        </div>
      </div>
    </nav>
  );
}
